import 'jquery'
import 'select2';

import TOC from './js/TOC';
import Breadcrumb from './js/Breadcrumb';
import Currency from './js/Currency';
import Select2fn from './js/select2fn';

export default {
  TOC,
  Breadcrumb,
  Currency,
  Select2fn
}
